import React, { useEffect, useState } from 'react';
import './ChatScroll.css';
import 'intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import { fetchSuggestions } from '../../store/Suggestions/SuggestionsActions';
import { loadMessages } from '../../store/Messages/MessagesActions';
import { getMessages } from '../../store/Messages/MessagesSelectors';
import HomeView from '../HomeView/HomeView';
import ChatView from '../ChatView/ChatView';
import { setTenantConfig } from '../../store/Config/ConfigActions';
import { getTenantConfig } from '../../store/Config/configSelectors';
import arrow from '../../Assets/Images/myuti-arrow-right.png';
import bubble from '../../Assets/Images/myuti-bubble.png';
import mya from '../../Assets/Images/myuti-mya.png';
import close from '../../Assets/Images/myuti-close.png';
import TextInput from '../TextInput/TextInput';
import { getLimitReached } from '../../store/Messages/MessagesSelectors';
import { sendMessageAction } from '../../store/Messages/MessagesActions';
import sendIcon2 from '../../Assets/Images/myuti-send.png';

const configFileName = process.env.REACT_APP_CONFIG_FILE;
const config = require(`../../TenantConfig/${configFileName}`);

const ChatScroll = () => {
  const dispatch = useDispatch();

  const [home, setHome] = useState(true);

  const userId = useSelector(getUserId);
  const messages = useSelector(getMessages);
  const tenantConfig = useSelector(getTenantConfig);
  const limitReached = useSelector(getLimitReached);

  useEffect(() => {
    if (config) {
      dispatch(setTenantConfig(config));
    }
  }, [config]);

  useEffect(() => {
    // Set the document title based on the config
    document.title = tenantConfig.pageTitle || 'Ema';
  }, [tenantConfig.pageTitle]);

  const initialPrompt = new URLSearchParams(window.location.search).get(
    'initialPrompt',
  );

  useEffect(() => {
    // If tenantConfig includes an initialPrompt, ensure ChatView is shown immediately.
    if ((tenantConfig && tenantConfig.initialPrompt) || initialPrompt) {
      setHome(false);
    }
  }, [tenantConfig, initialPrompt]);

  // useEffect(() => {
  //   if (userId) {
  //     dispatch(loadMessages(userId));
  //     setHome(false);
  //   }
  // }, [userId]);

  useEffect(() => {
    if (tenantConfig.tenant) {
      dispatch(fetchSuggestions()); // Fetch suggestions on mount
    }
  }, [tenantConfig]);

  const generateTranscript = () => {
    let bufferString = '';
    messages.forEach(message => {
      bufferString +=
        (message.type === 'ema' ? 'Ema: ' : 'You: ') + message.message + '\n\n';
    });
    return bufferString;
  };

  const downloadTranscript = () => {
    const transcript = generateTranscript();
    const element = document.createElement('a');
    const file = new Blob([transcript], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'myChat.txt';
    document.body.appendChild(element); // Required to work in FireFox
    element.click();
  };

  // const regenerateResponse = () => {
  //   sendMessage(lastMessage);
  // };

  const sendMessage = async message => {
    setHome(false);
    dispatch(sendMessageAction(message));
  };

  return (
    <div className="Outer-Wrapper">
      <div
        className="fixed-icon"
        id="close-chat"
        onClick={() => window.parent.postMessage('closeChat', '*')}
      >
        <img
          src={arrow}
          alt="Icon"
          style={{ width: 36, height: 19, marginBottom: 5 }}
        />
      </div>

      <div className="header-container">
        <div className="header-wrapper">
          <img src={bubble} style={{ width: 91, height: 91 }} alt="bubble" />
          <div className="header-text-wrapper">
            <img src={mya} style={{ height: 56 }} alt="mya" />
            <div className="header-text">
              Your AI guide to UTIs and women’s health.
            </div>
          </div>
        </div>
      </div>

      {home ? (
        <HomeView setHome={setHome} />
      ) : (
        <ChatView
          setHome={setHome}
          initialPrompt={initialPrompt}
          sendMessage={sendMessage}
        />
      )}

      <div>
        {!limitReached && (
          <div className="convInput">
            <TextInput
              placeholder="Ask me anything..."
              style={{ marginLeft: '20px' }}
              disabled={false}
              onPress={message => {
                if (!limitReached) {
                  sendMessage({ type: 'user', message });
                }
              }}
            />
          </div>
        )}
        <div className="poweredByEma">Powered by Ema v1.0.3</div>
      </div>
    </div>
  );
};

export default ChatScroll;
